export const roundPrice = (price: number) => {
  return parseFloat(price.toFixed(2));
};

export const computeTTC = (price: number, tva: number): number => {
  return roundPrice(price + price * (tva / 100));
};

export const computeHT = (price: number, tva: number): number => {
  return roundPrice((price * 100) / (100 + tva));
};
